const MergedComponent = ({ components = [], value = {}, children }) =>
  components?.reduce((acc, Component) => <Component value={value}>{acc}</Component>, children)

export default MergedComponent
